<template>
  <ModalOverlay :id="writeReviewGuidelines" :title="guidelinesTitle" width="44.25rem">
    <template #body>
      <div class="review-guidelines-body">
        <div v-if="isPhotoGuidelines">
          <PhotoTemplate />
        </div>
        <div v-else-if="isVideoGuidelines">
          <VideoTemplate />
        </div>
        <div v-else>
          <WritingTemplate />
        </div>
      </div>
    </template>
  </ModalOverlay>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ModalOverlay from '@atomic-ui/modalOverlay/ModalOverlay';
import PhotoTemplate from './guidelines/PhotoTemplate.vue';
import VideoTemplate from './guidelines/VideoTemplate.vue';
import WritingTemplate from './guidelines/WritingTemplate.vue';
import { writeReviewGuidelines } from '../../../../constants/modals';
import { GUIDELINES_TYPES } from './constants';

type GuidelinesType = (typeof GUIDELINES_TYPES)[keyof typeof GUIDELINES_TYPES];

const props = defineProps<{
  type: GuidelinesType;
}>();

const isPhotoGuidelines = computed(() => props.type === GUIDELINES_TYPES.PHOTO);
const isVideoGuidelines = computed(() => props.type === GUIDELINES_TYPES.VIDEO);
const guidelinesTitle = computed(() => {
  if (isPhotoGuidelines.value) return 'Photo guidelines';
  if (isVideoGuidelines.value) return 'Video guidelines';
  return 'Writing guidelines';
});
</script>

<style scoped lang="scss">
@import '~settingSCSS';
:deep(p) {
  @include margin-bottom-xs;
}
:deep(ul) {
  @include margin-bottom-xs;
  @include margin-left-xs;
  @include padding-left-xxs;
}
</style>
